import { AppKind } from "@/common/model";

/** Display metadata for each app in the catalog (ADR-061). The kinds themselves come from the schema. */
export const APP_CATALOG: Record<
	AppKind,
	{ name: string; description: string }
> = {
	[AppKind.GIT_HUB]: {
		name: "GitHub",
		description:
			"Workspaces connect a GitHub App installation to browse repositories and link them to projects.",
	},
	[AppKind.PORT]: {
		name: "Port",
		description:
			"Connection to Port.io that synchronizes the workspace with Port and lets Port perform work in it, both ways.",
	},
};

/** Catalog order for lists. */
export const APP_KINDS: readonly AppKind[] = [AppKind.GIT_HUB, AppKind.PORT];
